module.exports={select:"선택",selected:"선택됨"};